export default __webpack_public_path__ + "static/media/25th live on banner.4cb4e909.jpg";